import script from "./AvatarUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AvatarUploader.vue?vue&type=script&setup=true&lang=ts"

import "./AvatarUploader.vue?vue&type=style&index=0&id=4a239da5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a239da5"]])

export default __exports__